import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { SSOLoginStyled } from "../../../asset/styled/SSOLoginStyled";
import DetailHeader from "../../../components/header/DetailHeader";
import Typography from "../../../components/common/Typography";
import AutoComplete from "../../../components/common/AutoComplete";
import Button from "../../../components/common/Button";
import { getComAlias } from "../loginSlice";
import { getAlertMessageFunction } from "../../../common/Util";

const SSOLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation('login');
  const { t: tCommon } = useTranslation('common');
  const [isActive, setIsActive] = useState(false);
  const [htmComCd, setHtmComCd] = useState('');
  const [selectedCompany, setSelectedCompany] = useState(null);
  const companyList = [
    // {
    //   htmComNm: "우아한형제들",
    //   htmComCd: "woowahan",
    // },
    {
      htmComNm: "주식회사 씨젠",
      htmComCd: "seegene",
    },
    {
      htmComNm: "콘센트릭스서비스코리아 유한회사",
      htmComCd: "CNXKR",
    },
    // {
    //   htmComNm: "한국교육과정평가원",
    //   htmComCd: "kice",
    // },
  ];

  const handleSelect = (item) => {
    if (item) {
      setSelectedCompany(item);
      setHtmComCd(item.htmComCd);
      setIsActive(false);
    } else {
      setSelectedCompany(null);
      setHtmComCd("");
    }
  };

  const handleConfirm = () => {
    const alertMessage = getAlertMessageFunction();
    if (htmComCd.trim() == "") {
      alertMessage('올바른 회사 이름을 입력해 주세요.');
      return;
    } else {
      dispatch(getComAlias({ htmComCd: htmComCd }));
    }
  }

  return (
    <>
      <DetailHeader title={tCommon('header.title15')} />
      <SSOLoginStyled>
        <div className="displayFlexColumn" style={{ gap: '8px' }}>
          <Typography variant="subtitleBold">{t('ssoButton')}</Typography>
          <Typography variant="body2Medium">{t('ssoLoginDescription')}</Typography>
        </div>
        <AutoComplete
          placeholder={t('companyName')}
          size="large"
          dataList={companyList}
          onSelect={handleSelect}
          selectItem={selectedCompany?.htmComNm}
          isActive={isActive}
          setIsActive={setIsActive}
          inputStyle={{ width: "100%" }}
          dataBoxStyle={{ width: "100%" }}
        />
        <div className="displayFlexColumn" style={{ gap: '10px' }}>
          <Button size="large" value={tCommon('confirm')} onClick={handleConfirm} />
          <Button 
            size="large" 
            variant="outline" 
            value={tCommon('cancel2')} 
            onClick={() => navigate('/login')} 
          />
        </div>
      </SSOLoginStyled>
    </>
  )
}

export default SSOLogin;